import { PeerSupportGroupCreate } from "./peerSupportGroupCreate";
import { PeerSupportGroupEdit } from "./peerSupportGroupEdit";
import { PeerSupportGroupList } from "./peerSupportGroupList";
import { PeerSupportGroupShow } from "./peerSupportGroupShow";

export default {
	create: PeerSupportGroupCreate,
	edit: PeerSupportGroupEdit,
	list: PeerSupportGroupList,
	show: PeerSupportGroupShow,
};
